// src/ConsumerApp/api/invoices/invoice.service.js
import { apiClient } from '../apiClient';

const BASE_URL = (
  process.env.REACT_APP_BASE_URL ||
  process.env.REACT_APP_FORE_BRICKBUCKET ||
  'https://backend.brickbucket.in/'
).replace(/\/+$/, '');

export const InvoiceService = {
  /**
   * Fetch all customer tax invoices and receipts
   */
  getAllCustomerInvoices: async (customerId) => {
    const response = await apiClient.get(
      `/brickbucket/invoice/get-all-customer-invoices?customer_id=${customerId}`
    );
    return response.data || response;
  },

  /**
   * Browser PDF download trigger
   */
  downloadInvoicePdf: async (fileRelativePath, invoiceNumber, token) => {
    const fileUrl = `${BASE_URL}/brickbucket/uploads/${fileRelativePath}`;

    const response = await fetch(fileUrl, {
      method: 'GET',
      headers: {
        ...(token ? { 'x-token': token } : {}),
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to download invoice (HTTP ${response.status})`);
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `${invoiceNumber || 'Invoice'}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  },
};